(function () {
  // Unicode vulgar fractions → decimal, for parsing authored amounts
  var UNI = { '½': 0.5, '⅓': 1 / 3, '⅔': 2 / 3, '¼': 0.25, '¾': 0.75, '⅛': 0.125, '⅜': 0.375, '⅝': 0.625, '⅞': 0.875, '⅕': 0.2, '⅖': 0.4, '⅗': 0.6, '⅘': 0.8, '⅙': 1 / 6, '⅚': 5 / 6, '⅐': 1 / 7, '⅑': 1 / 9, '⅒': 0.1 };

  // Pull a leading quantity off an amount string ("1 ½ cups" → {num:1.5, tail:" cups"}).
  // Returns null when the amount doesn't start with a number (e.g. "a pinch") so it's left as-is.
  function parseLeadingQty(str) {
    var s = String(str);
    var num = null, len = 0;
    var frac = s.match(/^\s*(?:(\d+)\s+)?(\d+)\/(\d+)/); // ascii fraction, mixed ("1 1/2") or bare ("1/2")
    if (frac) {
      num = (frac[1] ? parseInt(frac[1], 10) : 0) + parseInt(frac[2], 10) / parseInt(frac[3], 10);
      len = frac[0].length;
    } else {
      var dec = s.match(/^\s*(\d+(?:\.\d+)?)/); // whole or decimal
      if (dec) {
        num = parseFloat(dec[1]);
        len = dec[0].length;
        var uni = s.slice(len).match(/^\s*([¼-¾⅐-⅞])/); // trailing unicode fraction ("1 ½" / "1½")
        if (uni && UNI[uni[1]] !== undefined) { num += UNI[uni[1]]; len += uni[0].length; }
      } else {
        var u = s.match(/^\s*([¼-¾⅐-⅞])/); // bare unicode fraction ("½")
        if (u && UNI[u[1]] !== undefined) { num = UNI[u[1]]; len = u[0].length; }
      }
    }
    if (num === null) return null;
    return { num: num, tail: s.slice(len) };
  }

  var FRACS = [[0.125, '⅛'], [0.25, '¼'], [1 / 3, '⅓'], [0.375, '⅜'], [0.5, '½'], [0.625, '⅝'], [2 / 3, '⅔'], [0.75, '¾'], [0.875, '⅞']];
  function fmtQty(v) {
    if (v < 0) v = 0;
    var whole = Math.floor(v + 1e-9), frac = v - whole;
    if (frac < 0.06) return String(whole);
    var best = '', bestD = 0.08;
    for (var i = 0; i < FRACS.length; i++) { var d = Math.abs(frac - FRACS[i][0]); if (d < bestD) { bestD = d; best = FRACS[i][1]; } }
    if (best) return (whole ? whole + ' ' : '') + best;
    return String(Math.round(v * 100) / 100);
  }

  function initServes(root) {
    var li = root.querySelector('.recipe-meta__serves');
    if (!li) return;
    var base = parseInt(li.getAttribute('data-serves-base'), 10);
    if (!base || base < 1) return;
    var valEl = li.querySelector('[data-serves-val]');
    var dec = li.querySelector('[data-serves-dec]');
    var inc = li.querySelector('[data-serves-inc]');
    var reset = li.querySelector('[data-serves-reset]');
    var amounts = root.querySelectorAll('.recipe-ingredient__amount[data-amount]');
    var serves = base;
    var MAX = Math.max(12, base * 4);

    function render() {
      valEl.textContent = serves;
      var ratio = serves / base;
      amounts.forEach(function (el) {
        var orig = el.getAttribute('data-amount');
        var p = parseLeadingQty(orig);
        el.textContent = p ? fmtQty(p.num * ratio) + p.tail : orig;
      });
      if (reset) reset.hidden = serves === base;
    }

    if (dec) dec.addEventListener('click', function () { if (serves > 1) { serves--; render(); } });
    if (inc) inc.addEventListener('click', function () { if (serves < MAX) { serves++; render(); } });
    if (reset) reset.addEventListener('click', function () { serves = base; render(); });
  }

  function postAdd(items, btn) {
    var visible = btn ? btn.querySelector('.btn') : null;
    if (visible) visible.classList.add('btn--loading');
    return fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({ items: items }),
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status === 422 || data.status === 'bad_request') {
          if (data.description) alert(data.description);
        } else {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data, addToCartBtn: btn } }));
        }
        if (visible) visible.classList.remove('btn--loading');
      })
      .catch(function () { if (visible) visible.classList.remove('btn--loading'); });
  }

  function init(root) {
    root.querySelectorAll('[data-shop-ingredient]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-variant-id');
        if (id) postAdd([{ id: id, quantity: 1 }], btn);
      });
    });

    var addAll = root.querySelector('[data-add-all]');
    if (addAll) addAll.addEventListener('click', function () {
      var ids = (addAll.getAttribute('data-variant-ids') || '').split(',').filter(Boolean);
      if (!ids.length) return;
      postAdd(ids.map(function (id) { return { id: id, quantity: 1 }; }), addAll);
    });

    var printBtn = root.querySelector('[data-recipe-print]');
    if (printBtn) printBtn.addEventListener('click', function () { window.print(); });

    initServes(root);
  }

  function boot() { document.querySelectorAll('[data-recipe-detail]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
